module Environments {
    module.controller("EnvironmentsListController", [
        "$scope",
        "$uibModal",
        "EnvironmentsService",
        "notifications",
        function ($scope, $modal, environmentsService, notifications) {
            $scope.environments = environmentsService.all();
            $scope.saveEnvironmentRequest = false;
            $scope.saveEnvironment = function (env) {
                $scope.saveEnvironmentRequest = true;
                environmentsService.save(env).then(function (response) {
                    $scope.saveEnvironmentRequest = false;
                    if (response) {
                        notifications.notify(response.data.message);
                        var updatedEnv = response.data.updatedEnvironment;
                        var index = _.findIndex($scope.environments, function (e: IEnvironment) { return e.name === env.name; });
                        $scope.environments[index] = updatedEnv;
                        $scope.$state.go("environments.detail", { environmentName: updatedEnv.name});
                    }
                });
            };

            $scope.remove = function ($event, env) {
                $event.preventDefault();
                $event.stopPropagation();

                var deleteConfirmation = $modal.open({
                    templateUrl: "DeleteConfirmationModalPartial",
                    size: "lg",
                    resolve: {
                        itemType: function () { return FRENDS.Localizations.Environment.toLowerCase() },
                        itemName: function () { return env.name; }
                    },
                    controller: "DeleteConfirmationModalController as ctrl"
                });

                deleteConfirmation.result.then(function () {
                    if (env.agentGroups.length > 0) {
                        notifications.error(FRENDS.Localizations.Environment_CouldNotRemove_HasAgentGroups);
                        return;
                    }

                    if (env.isNew) {
                        // This environment is not saved to the server yet. Just remove it from JS memory.
                        $scope.environments = _.without($scope.environments, env);
                        $scope.$state.go("environments.detail", { environmentName: "Default" });
                    } else {
                        // The server knows about this environment. Do the delete request.
                        environmentsService.remove(env).then(function (response) {
                            if (response) {
                                notifications.notify(response.data);
                                $scope.environments = _.without($scope.environments, env);
                                $scope.$state.go("environments.detail", { environmentName: "Default" });
                            }
                        });
                    }
                });
            };
            $scope.isCurrent = function (env: IEnvironment) {
                var newEnv = ($scope.$state.current.name === "environments.new") && env.isNew;
                return $scope.$state.params.environmentName === env.name || newEnv;
            };

            $scope.isCurrentAgentGroup = function(agentGroup: IAgentGroup) {
                var newGroup = ($scope.$state.current.name === "environments.agentGroup.new") && agentGroup.isNew;
                return $scope.$state.params.agentGroupName === agentGroup.name || newGroup;
            }

            $scope.getEnvironmentStatus = function (environment) {
                var failing = _.some(environment.agents, function (agent:IAgent) {
                    return agent.errorEventDuringLastDay;
                });
                var allUnknown = _.every(environment.agents, function (agent:IAgent) {
                    return agent.lastStatus === FRENDS.Localizations.Unknown;
                });

                var status;
                if (failing) {
                    // At least one agent in this environment has an error during the last day.
                    status = "status-failing";
                } else if (allUnknown) {
                    // None of the agents failed in the last day, but all have status "unknown"
                    status = "status-neutral";
                } else {
                    // None of the agents failed in the last day, can be a mix of "unknown" and "OK"
                    status = "status-passing";
                }
                return status;
            };
            $scope.agentDetailsState = function () {
                return $scope.$state.current.name === "environments.detail.agent.detail";
            };

            if ($scope.$state.current.name === "environments") {
                $scope.$state.go("environments.detail");
            }
        }
    ]);
}